module.exports = __webpack_public_path__ + "img/scientificIcon03.8af3e1b5.png";